import * as Yup from 'yup'

const yupUnit = Yup.object().shape({
  formInput: Yup.object().shape({
    unitName: Yup.string().required('Pleses Enter Unit Name'),
  }),
})

export default yupUnit
